export default __webpack_public_path__ + "static/15_18-a3df7e4032e08cbff7eb6aabcfec3090.png";